<template>
	<div class="progress-item">
		<div v-for="(item, index) in data" :key="index" class="item">
			<div class="icon">
				<div class="top">{{ index + 1 }}</div>
				<svg-icon name="top" :size="30" :color="item.color"></svg-icon>
			</div>
			<div class="flex-item">
				<div class="val">
					<div>{{ item.name }}</div>
					<div>{{ item.value }}个</div>
				</div>
				<div>
					<el-progress :percentage="32.5" :stroke-width="10" color="#4080FF" :show-text="false"></el-progress>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LeasedCustomerTop',
		props: {
			data: {
				type: Array,
				default: () => [
					{
						name: '李向阳',
						value: 85,
						color: '#FFC142',
					},
					{
						name: '李向阳',
						value: 85,
						color: '#FF7F85',
					},
					{
						name: '李向阳',
						value: 85,
						color: '#6DA8FA',
					},
					{
						name: '李向阳',
						value: 85,
						color: '#B4B6BD',
					},
					{
						name: '李向阳',
						value: 85,
						color: '#B4B6BD',
					},
					{
						name: '李向阳',
						value: 85,
						color: '#B4B6BD',
					},
				],
			},
		},
		computed: {
			// total() {
			// 	return this.categories.reduce((sum, item) => sum + item.value, 0);
			// },
		},
		methods: {},
	};
</script>

<style lang="scss" scoped>
	.progress-item {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		font-weight: bold;
	}

	.item {
		display: flex;
		align-items: center;
		gap: 12px;
	}
	.flex-item {
		flex: 1;
	}
	.val {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
		font-size: 14px;
		color: #000000;
	}
	.icon {
		position: relative;
	}
	.top {
		color: #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -20%);
		font-size: 12px;
		font-weight: normal;
	}
</style>
